import axiosInstance from '../../../config/axiosInstance';
const  ContractDocumentService = {
    async GetAllAgreementDocuments(redirectCallback,ID) {
        try {            
            const response = await axiosInstance.get(`/Agreement/GetContractDocument?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteAgreementDocument(redirectCallback,ID) {
        try {            
            const response = await axiosInstance.get(`/Agreement/DeleteContractDocument?ID=${ID}`);
            return response.data;
        } catch (error) {
            
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default ContractDocumentService;